import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"arrow-left\">\n<title>arrow-left</title>\n<path d=\"M7.786 1.458c0.326-0.377 0.273-0.938-0.118-1.252s-0.974-0.263-1.3 0.114l-6.154 7.111c-0.285 0.33-0.285 0.808 0 1.138l6.154 7.111c0.326 0.377 0.908 0.428 1.3 0.114s0.445-0.875 0.118-1.252l-5.661-6.542 5.661-6.542z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol